import React from "react";
import { months } from "../../../../../../Utils/months";
import { RowNames } from "../../../Utils/TableComponents";
import { DatosEditablesSolidos, TotalRowNames } from "../Data/SolidosData";
import SolidosMonth from "./SolidosMonth";


export default function SolidosTable() {
    const editableRowNames = Object.values(DatosEditablesSolidos).map(item => item.rowName);

    const rowNames = [...editableRowNames, ...TotalRowNames];

    return (
        <div className="report__table-container report__solidos-table-container">
            <h6>SÓLIDOS</h6>
            <div className="report__month-tables">
                <RowNames rowNames={rowNames} totalRows={[10, 12]} />
                {months.map((month, index) => {
                    return (<SolidosMonth key={index} month={month} monthIndex={index} />)
                })}
            </div>
        </div>
    );
}
